import { Component, OnInit, ChangeDetectorRef } from '@angular/core'
import { MatSnackBar } from '@angular/material'
import { NavigationEnd, Router } from '@angular/router'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { ConsultationService, DialogService, DossierService } from '../../services'
import { ConfirmComponent } from '../../views/partials/layout/dialogs/confirm-dialog/confirm.component'
import { NomadeService } from '../services/nomade.service'

@Component({
	selector: 'atyl-nomade-adder',
	templateUrl: './adder.component.html',
	styleUrls: ['./adder.component.scss']
})
export class AdderComponent implements OnInit {

	shown = false
	currentDossier: any
	currentConsultation: any
	ID: any
	type: string
	constructor(private dialogService: DialogService,
		private router: Router,
		private nomadeService: NomadeService,
		private dossierService: DossierService,
		private consultationService: ConsultationService,
		private _snackbar: MatSnackBar,
        private cdr: ChangeDetectorRef
	) { }
	ngOnInit(): void {
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				const urlParts = event.url.split('/')
				if (event.url.includes('/home/dossier') || event.url.includes('/home/consultation/')) {
					this.shown = true
					this.ID = urlParts[urlParts.length - 1]
                    if(urlParts[2] == "consultation") {
                        this.type = "séance";
                    } else {
                        this.type = urlParts[2]
                    }
				}
                else{
                    this.shown = false
                }
				// hide the adder when navigating to the consultation index page and show it when we are in single consultation page
                /*
				if (event.url == "/home/consultation") {
					this.shown = false
				}*/
				console.log(this.type)
			}
		})
	}
 
	openConfirm(event: MouseEvent) {

		this.dialogService.open(ConfirmComponent, {
			draggable: true,
			resizable: false,
			minimizable: false,
			maximizable: false,
			width: '25vw',
			height: '25vh',
			data: {
				libelle: `Etes-vous sûr de vouloir ajouter ${this.type == 'dossier' ? 'ce' : 'cette'} ${this.type} ?`,
			}
		}, (res: any) => {
			if (res) {
				this.shown = false
				if (this.type == "dossier") {
					this.dossierService.get(this.ID).subscribe((response: JSONRpcResponse) => {
						this.currentDossier = response.result
					}, err => {
						console.error(err)
					}, () => {
						this.nomadeService.addSavedDossier(this.currentDossier)
						const snackBarRef = this._snackbar.open('Dossier ajouté', 'Voir le mode nomade', {
							duration: 2000,
						})
						snackBarRef.onAction().subscribe(() => {
							this.router.navigate(['/home/nomade'])
						})
					})
				}
				if (this.type == "consultation" || this.type == "séance") {
					this.consultationService.getconsultation(this.ID).subscribe((response: JSONRpcResponse) => {
						this.currentConsultation = response.result
					}, (err) => {
						console.error(err)
					}, () => {
						console.log(this.currentConsultation, "consultation current")
						this.nomadeService.addSavedConsultation(this.currentConsultation)
						const snackBarRef = this._snackbar.open('Séance ajoutée', 'Voir le mode nomade', {
							duration: 2000,
						})
						snackBarRef.onAction().subscribe(() => {
							this.router.navigate(['/home/nomade'])
						})
					})
				}
                this.cdr.detectChanges();
			}
		})

	}
}
